import React from 'react'
import createClass from 'create-react-class'
import ExtensionUi from 'live/components/extensions/ui/base'
import i18n from 'live/services/i18n'
import Container from './container'

const ObjectInitializerMixin = require('live/components/forms/mixins/object-initializer')('/rest/extension')


export default createClass({
    mixins: [ObjectInitializerMixin],
    getInitialState() {
        return ({})
    },
    render() {

        const qualify = this.state.object.qualifier;
        return <ExtensionUi className="files-tab"  {...this.props}
            uiCfg={{ headerSubtitle: null }} noFetch={true} loading={false} instance={this.state.object}>
            {
                qualify ? <Container qualifier={this.state.object.qualifier} alwaysDeleteFile={
                    this.state.object.config.alwaysDeleteFile} /> : null
            }
        </ExtensionUi>
    }

})
